import { createApi } from '@reduxjs/toolkit/query/react';
import { CmsContentApiVersions } from '../cms-content-api-service';
import { getBaseQuery } from '../cms-content-api-service-redux';
export const tjenesteTeksterApi = createApi({
    reducerPath: 'tjenesteTeksterApi',
    baseQuery: getBaseQuery,
    endpoints: builder => ({
        getTjenesteTekster: builder.query({
            query: ({ navn, childPage, languageCode }) => ['tjeneste', { navn, childPage, languageCode }, CmsContentApiVersions.V2],
        }),
    }),
});
export const { useGetTjenesteTeksterQuery } = tjenesteTeksterApi;
